export * from './AccentText';

//# sourceMappingURL=index.js.map